<template>
  <div class="page_qwNotify">
    <div v-html="contData" class="contBox"></div>
    <br/>
  </div>
</template>

<script>
  import xz from "@/common";
  // import candidate from "./components/candidate.vue";
  export default {
    components: {},
    data() {
      return {
        Id: '',
        loading: false,
        contData: '',
      }
    },
    async created() {
      this.$store.commit('setHiddenLeft', true)
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.Id = this.$route.query.id;
        this.GetEnterpriseNotification();
      }
    },
    methods: {
      GetEnterpriseNotification() {
        this.loading = true;
        xz.GetEnterpriseNotification(this.Id).then(res => {
          if (res.status == 'ok') {
            this.contData = res.data
          } else {
            this.contData = ''
          }
        })
      }
    }
  }
</script>
<style scoped>
.page_qwNotify{
  min-height: 100vh;
  background: #fff;
}
.contBox{
  font-size: 16px;
  padding: 20px 30px;
  line-height: 34px;
}
</style>